import { ACCEPT_IMAGE_MIMETYPE, MAX_IMAGE_RATIO, MIN_IMAGE_AREA } from '@/app/constants';
import type { ImageValidationReason } from './validate-image-file';

/**
 * 第 1 步：MIME 白名单。
 *
 * 输入文件的 MIME 类型，命中白名单返回 null，否则返回 'invalidType'。
 */
export function checkImageMime(fileType: string): ImageValidationReason | null {
  return ACCEPT_IMAGE_MIMETYPE.includes(fileType) ? null : 'invalidType';
}

/**
 * 第 2 步：magic byte 校验。
 *
 * 输入是 `detectImageType` 解析出来的实际格式（如 'png' / 'jpeg' / 'webp'），
 * 不在白名单或解析失败（null/undefined）时返回 'incorrectExtension'。
 */
export function checkImageMagicByte(detected: string | null | undefined): ImageValidationReason | null {
  if (!detected || !ACCEPT_IMAGE_MIMETYPE.includes(detected)) return 'incorrectExtension';
  return null;
}

/**
 * 第 3 步：文件大小。超过上限返回 'invalidSize'。
 */
export function checkImageSize(byteSize: number, maxFileSize: number): ImageValidationReason | null {
  return byteSize > maxFileSize ? 'invalidSize' : null;
}

/**
 * 第 4 步纯逻辑部分：宽高 → reason。
 *
 * - 面积小于 `MIN_IMAGE_AREA` → 'invalidArea'
 * - 任一边比超过 `MAX_IMAGE_RATIO` → 'invalidRatio'
 * - 否则返回 null
 */
export function checkImageDimension(width: number, height: number): ImageValidationReason | null {
  if (width * height < MIN_IMAGE_AREA) return 'invalidArea';
  if (width / height > MAX_IMAGE_RATIO || height / width > MAX_IMAGE_RATIO) return 'invalidRatio';
  return null;
}
